<div app-sidenav>
  <div class="flex items-center justify-between">
    <h1 translate class="text-xl font-normal text-theme-950">trilhas.categoria</h1>
    <div class="group flex w-1/12 justify-center p-1"></div>
  </div>
  <div class="-mx-24 my-5 border border-theme-500"></div>
  <form [formGroup]="form">
    <app-form-field>
      <label app-label translate class="text-2xl text-theme-950">trilhas.nome-categoria-sidenav</label>
      <input
        app-input
        (keyup.enter)="onSave()"
        formControlName="nome"
        class="block leading-5"
        type="text"
        [placeholder]="'trilhas.escreva-categoria' | translate"
      />
    </app-form-field>
  </form>
  <div class="mt-8 flex w-full items-center gap-5">
    <button
      type="button"
      (click)="onClose()"
      app-outline-button
      translate
      class="!h-10 w-1/2 border-base-status-danger text-base-status-danger hover:[&:not([disabled])]:bg-base-status-danger hover:[&:not([disabled])]:text-theme-contrast"
    >
      trilhas.cancelar
    </button>
    <button
      type="button"
      (click)="onSave()"
      app-outline-button
      translate
      class="!h-10 w-1/2 border-theme-800 text-theme-800 hover:[&:not([disabled])]:bg-theme-800 hover:[&:not([disabled])]:text-theme-contrast"
    >
      trilhas.salvar
    </button>
  </div>
</div>
